/*eslint-disable*/ export const messages = JSON.parse("{\"page-indicator.aria.label\":[\"Piste \",[\"selectedPage\"],\" on korostettuna \",[\"pageCount\"],\" pisteen rivissä\"]}");
//# sourceMappingURL=messages.mjs.map